import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class FmeaApi {
  static async Create(data: {
    // code: number;
    title: string;
    description?: string;
    fmeaType: number;
    responsible: string;
    sublineId?: string;
    productId?: string;
    status: number;
  }): Promise<any> {
    const response = await ApiHandler(baseURL).post("/Fmeas", data);
    return response.data;
  }

  static async Update(fmea: {
    id: string;
    title: string;
    description?: string;
    responsible: string;
    status: number;
    fmeaType: number;
    createdAt?: string;
    updatedAt?: string;
    productId?: string;
  }): Promise<any> {
    const response = await ApiHandler(baseURL).put(`/Fmeas/${fmea.id}`, fmea);
    return response.data;
  }
  static async GetAllFmeas(): Promise<any> {
    const response = await ApiHandler(baseURL).get("/Fmea/GetAll");
    return response.data;
  }
  static async GetByFilterAsync(
  plantIds: string[] = [],
  pageNumber: number = 1,
    pageSize: number = 10,
    sortField: string = "code",
    sortDirection: string = "asc",
    code?: number,
    title?: string,
    fmeaType?: number, // Enum (ex: 0, 1, 2...)
    status?: string[], // Enum (ativo, rascunho, desativado...)
    productIds?: string[],
    productionUnitIds?: string[],
    areaIds?: string[],
    lineIds?: string[],
    subLineIds?: string[],
  ): Promise<any> {
    let url = `/fmeas/filter?`;

    // Paginação e ordenação
    url += `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    url += `&sortField=${encodeURIComponent(sortField)}`;
    url += `&sortDirection=${encodeURIComponent(sortDirection)}`;

    // Filtros básicos
    if (title) url += `&title=${encodeURIComponent(title)}`;
    if (fmeaType !== undefined) url += `&fmeaType=${fmeaType}`;
    if (code !== undefined) url += `&code=${code}`;

    // Filtros encadeados
    // Filtro por planta
    plantIds.forEach((id) => {
      url += `&plantIds=${encodeURIComponent(id)}`;
    });
    productionUnitIds?.forEach((id) => {
      url += `&productionUnitIds=${encodeURIComponent(id)}`;
    });

    areaIds?.forEach((id) => {
      url += `&areaIds=${encodeURIComponent(id)}`;
    });

    lineIds?.forEach((id) => {
      url += `&lineIds=${encodeURIComponent(id)}`;
    });

    subLineIds?.forEach((id) => {
      url += `&subLineIds=${encodeURIComponent(id)}`;
    });
    productIds?.forEach((id) => {
      url += `&productIds=${encodeURIComponent(id)}`;
    });
    status?.forEach((id) => {
      url += `&status=${encodeURIComponent(id)}`;
    });

    return ApiHandler(baseURL).get(url);
  }

  static async GetById(id: string): Promise<any> {
    const response = await ApiHandler(baseURL).get(`/fmeas/${id}`);
    return response.data;
  }

  static async Delete(id: string): Promise<any> {
    const response = await ApiHandler(baseURL).delete(`/fmeas/${id}`);
    return response.data;
  }
  static async CheckForFamilyFmea(fmeaId: string): Promise<boolean> {
    const response = await ApiHandler(baseURL).get(
      `/fmeas/${encodeURIComponent(fmeaId)}/check-for-family-fmea`
    );
    return response.data;
  }

static async GetForFilter(params: {
  productIds?: string[];
  subLineIds?: string[];
  productionUnitIds?: string[];
  areaIds?: string[];
  lineIds?: string[];
}): Promise<any> {
  let url = "/fmeas/for-filter?";

  const appendArray: any = (name: string, arr?: string[]) => {
    if (!arr || arr.length === 0) return;
    arr.forEach((v) => {
      if (v) url += `${encodeURIComponent(name)}=${encodeURIComponent(v)}&`;
    });
  };

  appendArray("productIds", params.productIds);
  appendArray("subLineIds", params.subLineIds);
  appendArray("productionUnitIds", params.productionUnitIds);
  appendArray("areaIds", params.areaIds);
  appendArray("lineIds", params.lineIds);

  if (url.endsWith("&")) url = url.slice(0, -1);

  return ApiHandler(baseURL).get(url);
}

}
